import { useDataValue } from 'Simple/Data.js'
import { useMemo, useState, useEffect } from 'react'
import { storage } from 'Data/helpers.js'
import { STORAGE_KEY } from 'Data/constants.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let questions = useDataValue({
    context: 'widget',
    path: 'questions',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'flow_shortcuts',
    viewPath: props.viewPath,
    path: 'id',
  })

  let [previousState, setPreviousState] = useState(null)

  // Fetch the previous state from storage asynchronously
  useEffect(() => {
    let fetchPreviousState = async () => {
      try {
        let storedValue = await storage.getItem(`${STORAGE_KEY}_${id}`)
        if (storedValue) {
          setPreviousState(JSON.parse(storedValue))
        } else {
          setPreviousState(null) // Clear state if no stored value is found
        }
      } catch (err) {
        console.error('Error retrieving from storage:', err)
      }
    }

    fetchPreviousState()
  }, [id])

  // Compute newState based on questions and data
  let newState = useMemo(
    () => ({ ...data, flowQuestions: questions.map(item => item.id) }),
    [questions, data]
  )

  return useMemo(() => {
    if (!data) return data

    // Return parsed previous state if available, otherwise fallback to newState
    return {
      ...(previousState ?? newState),
    }
  }, [data, previousState, newState])
}
